<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter-Two.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="ch"><a id="Anchor-1"></a>CHAPTER TWO</p>
<p class="body-text-opening"><span class="lic" style="font-size:1.76em;" xml:lang="en-US">M</span>olly stood at the window watching as the
					delivery truck struggled down the driveway, this time leaving her alone with a
					diaper bag and a small baby. The hazy fog of ice crystals blocked the van from
					view in no time and the howling wind covered the hum of the disappearing motor.
					He was gone. And she was alone for the first time in two years with someone
					else’s baby.</p>
<p class="body-text">She hadn’t had a panic attack in the last six months, had
					believed she was finally past the painful valley of mourning, but she was near
					the point of panic now. The terror that closed off the windpipe and rattled the
					pulse wasn’t far from taking over. Drawing in a deep breath, she rested her
					cheek against the frozen windowpane and quoted the scripture Aunt Patsy had made
					her personalize and memorize. <em class="italic">God has not given me the
						spirit of fear. </em></p>
<p class="body-text">Even though she still struggled to believe that God was with
					her, helping her, the scripture somehow calmed her terror. It hadn’t at first,
					but over the months of constant repetition and Aunt Patsy’s gentle counsel,
					she’d slowly gained control over the attacks.</p>
<p class="body-text">A soft mewling sound issued from behind her. Whirling, hand at
					her tight throat, Molly hurried to the couch. True to his word, Ethan had moved
					the chair against the sofa and organized the cushions so that the baby wouldn’t
					fall, but he’d been wrong about her staying asleep. Wide awake, blue eyes gazing
					up at Molly, the child gnawed at a tiny pink fist.</p>
<p class="body-text">“God has not given me the spirit of fear,” she mumbled as she
					pulled a straight-backed chair next to the couch to be near the baby. Maybe if
					she watched the child every second nothing terrible would happen.</p>
<p class="body-text">The baby kicked and gooed, squirmed and sucked at her fist, but
					she didn’t go back to sleep. Molly sat rigidly, afraid to move, afraid even to
					blink. After fifteen minutes her neck muscles ached and she needed to go to the
					bathroom, a dilemma that meant leaving the baby alone—unthinkable—or picking her
					up—terrifying. The last baby she’d touched had been dead.</p>
<p class="body-text">Her scalp prickled from the memory. Baby Zack, his little body
					still warm, limp and lifeless against her chest as she ran screaming, screaming
					into the front yard of her sister’s house. Neighbors had come running, she
					didn’t know where from, though it was late summer when folks still enjoyed
					puttering in their gardens and cooking outside. One man carried a garden hoe to
					frighten away an attacker. But there was no attacker. And all the concerned
					neighbors in Winding Stair, Oklahoma, couldn’t help baby Zack.</p>
<p class="body-text">The panic started to crawl up Molly’s spine once more. Her grip
					on the chair would surely leave the imprint of her fingers in the wood. She had
					to hold on. She could not suffer a panic attack while this child was in her
					care.</p>
<p class="body-text">No telephone to call for help. No Aunt Patsy to talk her
					through. This time she’d have to rely on God alone.</p>
<p class="body-text">A glance at the anniversary clock resting on the fireplace
					mantel told her that Ethan had been gone all of thirty minutes. At this rate
					she’d be crazy before he returned.</p>
<p class="body-text">She refocused her attention on the baby. With a jolt, she saw
					that Laney’s eyes were now closed. Was she asleep or—? The awful thought forced
					her to do what she dreaded most. Fingers trembling, she reached out, slowly,
					slowly, and laid a hand on the flannel-clad chest.</p>
<p class="body-text">A shudder of relief rippled through her at the gentle rise and
					fall of the sleeping baby’s ribcage. Some nameless emotion stirred in Molly’s
					chest at the soft feel of an infant. Even the smell of her, that wonderful baby
					mixture of milk and lotion, made Molly’s chest ache with longing.</p>
<p class="body-text">Until Zack’s death she’d always dreamed of getting married and
					having a big family. Lots of kids. That’s what she’d told everyone. But now that
					would never happen. Her sister Chloe’s healthy, perfect six-month-old son had
					died while in her care. She must have done something wrong. Or maybe she hadn’t
					watched him closely enough. That’s what her sister had said the last time Molly
					had tried to ask forgiveness. </p>
<p class="body-text">As much as she’d wanted children, she could never take such a
					chance again. Chloe was right. Babies just weren’t safe with her.</p>
<p class="body-text">Rubbing gentle circles on the chest of the one now in her care,
					Molly felt an undeniable sense of loss.</p>
<p class="body-text">“You sure are a pretty thing,” she whispered.</p>
<p class="body-text">Dark eyelashes curled against rose-over-ivory cheeks, and her
					round face was topped by a cap of fine, dark hair. Molly couldn’t help but
					wonder about the mother. What had happened to her? And why had Ethan’s face gone
					all tense when Molly had asked about her?</p>
<p class="body-text">Healthy and well cared for, the baby looked to be about three
					or four months old, younger than Zack, but not by much. Her pink sleepers,
					emblazoned with the words Daddy’s Girl were clean and neat. Whatever Ethan
					Hunter’s situation with Laney’s mother, he loved his little girl.</p>
<p class="body-text">Samson rose from his spot near the fireplace, stretched his
					long gray feline body then padded across the room. Before Molly saw what he was
					about, the cat leaped onto the couch and tiptoed quietly toward the sleeping
					child.</p>
<p class="body-text">“Samson, no. Get down.” </p>
<p class="body-text">The cat, as usual, ignored her. He sniffed curiously at Laney’s
					mouth, an act that must have tickled, for the baby’s face scrunched up and she
					turned her head. Suddenly Laney remembered the old wives’ tale that a cat could
					steal a baby’s breath.</p>
<p class="body-text">With more force than she intended, she grabbed Samson and
					sailed him onto the floor. The shocked animal stared at her in resentment,
					flicked his tail and stalked to his rug by the crackling fireplace.</p>
<p class="body-text">Feeling worse than ever, Molly returned to her post beside the
					sleeping child. Cautiously, she placed her hand on the little chest once again
					and felt the movements that assured her the baby was breathing. If she had to
					sit this way all night long, she would. But oh, how she prayed that Ethan Hunter
					would soon return and take this responsibility off her shoulders.</p>
<p class="tb">* * *</p>
<p class="body-text-no-tab">Nearing midnight, eyes burning from staring into the
					frozen night, Ethan started back down the mountain. He hadn’t reached the
					Stubbs’s remote cabin until nearly nine o’clock, and the grateful couple had
					fortified him with coffee and brownies while the gamma infused into Chester’s
					blood system.</p>
<p class="body-text">During those hours with his patient the storm outside had
					worsened. The world around him was white and crystallized, a fairy tale turned
					into a nightmare. Chester and Mamie Stubbs had invited him to spend the night,
					but he’d refused. Laney was waiting. And from Molly’s reaction to his child, she
					was waiting, too—waiting for him to return and take the baby off her hands.</p>
<p class="body-text">A mighty gust whipped across an open pasture and the van rocked
					precariously.</p>
<p class="body-text">Ethan couldn’t remember ever driving—or flying—in an ice storm
					of this caliber. Since leaving the Stubbs’s farm he’d stopped over and over
					again to break ice off his windshield wipers. The delivery van wasn’t made to
					handle these conditions, and even chains on the tires wouldn’t have helped on
					what was now a solid sheet of ice.</p>
<p class="body-text">Shoulders hunched over the wheel, he stared hard into the
					night. His headlights reached only a few feet out into the blinding shower of
					white pellets. He could hardly tell where the road ended and the ditch began.
					Visibility was next to nothing. During his years as a paramedic helicopter pilot
					for a medical service he’d grown accustomed to flying by instruments when
					necessary. Too bad ground transport didn’t offer the same technology.</p>
<p class="body-text">Inch by inch, the van ground slowly forward. Like a shower of
					tiny rocks, ice tapped relentlessly against the outside. At this rate, he’d be
					hours getting back to Molly’s place. In the past he would have thrown caution to
					the wind and taken the necessary risks, but no more. Speeding up was a deadly
					game, and he had a baby waiting for him.</p>
<p class="body-text">Since the moment Twila had told him she was pregnant, Laney had
					become his sole focus in life. Though he’d felt safe in doing so, he disliked
					leaving her with Molly McCreight, a woman who obviously didn’t embrace the idea
					of caring for an infant. His jaw tensed, remembering Laney’s mother. What was
					the matter with women these days? Weren’t females naturally supposed to enjoy
					babies? </p>
<p class="body-text">He sighed heavily and squinted into the darkness. Maybe not.
					Maybe his was an old-fashioned dream. Just because his mother was a nurturer
					whose life had revolved around her kids, didn’t mean modern women felt the same.
					Mom was from a different era when home and family mattered.</p>
<p class="body-text">He’d had no choice but to leave Laney at the warm, safe farm.
					Even though she didn’t want Laney there, Ethan knew in his heart Molly McCreight
					would take good care of her. He didn’t know how he knew, but he knew. His baby
					was in good hands.</p>
<p class="body-text">Ice-coated wipers scraped across the windshield, doing little
					good, even with the defrosters blasting constant heat. Time to stop again and
					clear them off. The window, too, was coated in ever-thickening sleet. Easing to
					a crunching halt, he put the truck in Park, and took the can of de-icer and the
					ice scraper from the seat beside him. As he leaped from the truck the ice
					pellets hit him with the force of a sandblaster, driving into his cheeks and
					neck. He shuddered once, hunched his shoulders against the cold before setting
					to work.</p>
<p class="body-text">The world around him was a foreign place. Fence lines had
					disappeared and electric poles leaned threateningly. Before long there would be
					few landmarks to guide him. He’d have to be very careful.</p>
<p class="body-text">“Just me and You, Lord,” he said, and the wind slammed ice
					against his teeth.</p>
<p class="body-text">In the few short months since he’d become a Christian he’d said
					those words plenty of times. And now, as every time, he’d felt that calm
					assurance that he was not alone. No matter what happened, God would be here with
					him.</p>
<p class="body-text">Windshield cleared for the moment, he slammed back into the
					warm truck and dropped the gear into Low. The wheels spun but the van didn’t
					move. Accelerating slightly, Ethan felt the tires start to slide sideways. He
					fought against the skid, used every bit of his considerable expertise to bring
					the vehicle under control, but the ice was too much. In seconds, one side of the
					van tilted sideways into a ditch he hadn’t even known was there. </p>
<p class="body-text">With a sinking sensation in the pit of his stomach, Ethan got
					out to survey the situation.</p>
<p class="body-text">The van was hopelessly stuck. The Stubbs’ place was at least
					four miles back. He’d never be able to walk that far in this weather. But he
					couldn’t stay here either. No one would be along this road for days, maybe
					weeks. </p>
<p class="body-text">He had little choice but to walk to Molly McCreight’s
					farmhouse, even though he wasn’t sure how far that <br/>was. With a heavy sigh
					of dread, he bundled himself <br/>as much as possible for the trek, took the
					flashlight from beneath his seat and stepped out into the wretched storm. He
					gasped as a sharp north wind slammed into him. Tears stung his eyes. </p>
<p class="body-text">Less than ten minutes later ice encrusted his eyelashes and
					obscured his vision. He scraped at them, but his gloves, too, were covered with
					a fine layer of ice. Several times he slipped and nearly lost his footing, but
					he trudged on, keeping his focus on getting back to the baby he loved more than
					life itself. Thinking of Laney had given him the strength to do a lot of
					difficult things in the past year, and he thanked God every day for the gift of
					his daughter.</p>
<p class="body-text">Molly McCreight’s pinched face came to mind. He’d liked her the
					minute she’d pulled him into her house, welcoming him without even asking his
					business. And he’d liked her house. The neat country hominess—if that was a
					word—and the tantalizing fragrance of food cooking had reminded him of his
					parents’ home. </p>
<p class="body-text">He’d thought she was cute, too, with those brown-gold eyes and
					a sprinkle of freckles across her small nose. But from her reaction to his
					daughter, Molly was no different than Twila Thompson. </p>
<p class="body-text">Still, there was something about her that appealed to him. And
					thinking of Molly and Laney safe and warm in the old farmhouse helped him keep
					moving. </p>
<p class="body-text">Bending his neck against the north wind, Ethan shone the
					flashlight around him. No lights. No houses. Nothing. The flashlight danced
					wildly. For the first time, he noticed he was shivering and wondered when that
					had begun. His feet moved more slowly now, too. Even filtered through a muffler,
					the air hurt his lungs, burning so badly he could hardly stand to draw another
					breath. The scar over his eye throbbed painfully.</p>
<p class="body-text">He’d never been this cold before. With every step, sparks, like
					frozen electricity, shot through his feet. Ethan considered this a good sign.
					They weren’t frostbitten—yet.</p>
<p class="body-text">He had no idea how far he’d walked, but he did know one thing
					for certain. Hypothermia was setting in. If he didn’t find shelter soon, he’d
					freeze to death.</p>
<p class="body-text">The idea sent a surge of adrenaline into his bloodstream.
					Nothing could happen to him. Baby Laney depended upon him. He was all the parent
					she had.</p>
<p class="body-text">“Just me and You, Lord,” he muttered through stiff, numb lips. </p>
<p class="body-text">Snow and ice swirled around him, punishing him with every step,
					but the warm presence of God strengthened him.</p>
<p class="body-text">He’d gone less than fifty more feet when he spotted the feeble
					glow of yellow against the raging white night. Had he not been so cold and
					miserable, he’d have shouted for joy.</p>
<p class="body-text">He turned toward the light, trudging, struggling against the
					bitter wind and within minutes stumbled onto the now-familiar wooden porch.</p>
<p class="body-text">Without bothering to knock, he shoved open the door. And fell
					face first into Molly McCreight’s arms.</p>
<p class="tb">* * *</p>
<p class="body-text-no-tab">Molly wasn’t sure whether to scream in fright or praise
					God that Ethan Hunter was still breathing. He weighed a ton compared to her, and
					most of that weight was now shifted to her shoulders. She half dragged, half
					walked him to a big blue easy chair. Shudders racked his body. His skin was red
					and windburned. The ice frozen on his eyelashes tore at her heart.</p>
<p class="body-text">Where was his van? Had he had an accident? Had he made it to
					Chester’s place? </p>
<p class="body-text">“Ethan.” He was by far the most nearly-frozen human being she’d
					ever seen, but she saw no sign of other injuries. “Are you all right? What
					happened?”</p>
<p class="body-text">Stiff lips replied, “Heat exhaustion.”</p>
<p class="body-text">Molly held back a smile. Interesting man to joke under such
					dire conditions. </p>
<p class="body-text">“I’ll get something hot for you to drink. Stay right here.”</p>
<p class="body-text">Then she laughed at her own silliness. The man could barely
					move. After a quick glance at the baby, Molly hurried into the kitchen and
					shoved a cup of instant cocoa into the microwave. While the drink heated, she
					turned on the flame beneath the pot of beef stew. Ethan would need some hearty,
					hot food, too. Then she could find out what had happened.</p>
<p class="body-text">At the beep, beep of the microwave, Molly grabbed the thick
					brown mug and rushed back to the stranger in her living room. His head lay back
					and his eyes were closed, but he opened them the minute she reappeared.</p>
<p class="body-text">She offered him the steaming, rich-scented cocoa.</p>
<p class="body-text">With a shake of his head, he spoke through chattering teeth.
					“Too shaky. I’ll spill it.” </p>
<p class="body-text">Perplexed, Molly thought for a moment. He absolutely had to get
					warm—and fast. Ethan would be sick if she didn’t get him warmed up soon. If he
					fell ill in her house so far from town, she’d be left to care for him and his
					infant daughter. And for her peace of mind, she wanted him and his baby out of
					here as soon as possible.</p>
<p class="body-text">What he needed was a good hot bath to chase off the chill, but
					the idea of offering such a personal thing to a stranger was out of the
					question. The next best alternative was an electric blanket—and she did have
					that.</p>
<p class="body-text">“Will you be okay for a minute?”</p>
<p class="body-text">“Sure.” His ice-encrusted eyelids fell shut. His red-blue lips
					barely moved.</p>
<p class="body-text">“I’ll get some blankets, but first let’s move you closer to the
					fire.” </p>
<p class="body-text">Grabbing his ice-coated arm, she pulled as he heaved upward.
					They stumbled to the chair she’d pulled as close as possible to the blaze. As
					Ethan collapsed once more, he muttered, “Laney?”</p>
<p class="body-text">What a great dad. Even half-frozen, he still worried about his
					baby. “She’s asleep.” </p>
<p class="body-text">Molly gazed down at him for a second, curious to know more
					about a man strong enough to risk himself for someone else but tender enough to
					care for a tiny baby girl.</p>
<p class="body-text">He was definitely different than most men she knew.</p>
<p class="body-text">“I’ll be right back,” she said.</p>
<p class="body-text">In winter the back of the big, rambling house was closed off to
					preserve fuel. A trip into the frigid space was always made in haste, so in
					minutes, she was back in the living room, loaded with blankets.</p>
<p class="body-text">Ethan remained inert, but his chest rose and fell in
					exhaustion. The ice attached to his hair and clothes had begun to thaw. Small
					puddles formed around his feet. Damp spots appeared on his jacket and hat. His
					leather gloves dripped onto his pant legs.</p>
<p class="body-text">“You need to get out of that jacket and hat,” Molly said,
					reaching for the stocking cap. It came away, leaving behind a rumpled mess of
					brown hair.</p>
<p class="body-text">Ethan roused enough to struggle with his gloves. </p>
<p class="body-text">“Your fingers are numb. Let me.” Without considering the
					familiarity of such an action, Molly pulled the stiff, wet gloves from his
					hands, fretting over the reddened, icy fingers as she reached for the zipper on
					his jacket.</p>
<p class="body-text">At her touch, Ethan’s hand stayed hers. “I got it.”</p>
<p class="body-text">Suddenly embarrassed and more than a little self-conscious,
					Molly whirled toward the pile of blankets. Behind her, she heard the rustle of
					his jacket as she plugged in the electric blanket.</p>
<p class="body-text">“Sorry about the mess.”</p>
<p class="body-text">“Don’t be silly.” Molly draped the blanket around his
					shoulders, adding two others for insulation and an old quilt around his legs.
					“We’ll have you warmed up in no time.”</p>
<p class="body-text">“Appreciate it.” His head fell back against the old stuffed
					chair that had been her late uncle Ray’s favorite reading spot.</p>
<p class="body-text">Gradually, Ethan’s shudders subsided and he grew still. Except
					for the crackle of burning logs and the constant onslaught of sleet pecking at
					the windows, the room was unnervingly quiet.</p>
<p class="body-text">She wanted to turn on the television, check the weather, but
					worried the noise might disturb the baby.</p>
<p class="body-text">A jolt of fear, as powerful as an electrical shock, ripped
					through her.</p>
<p class="body-text">The baby. </p>
<p class="body-text">She had been so preoccupied with the near-frozen Ethan that
					she’d momentarily forgotten Laney. Was she all right? </p>
<p class="body-text">Knees going weak, throat dry as talcum powder, Molly was afraid
					to look at the makeshift baby bed. </p>
<p class="body-text">Her breath grew short and her heart rate accelerated as the
					beginnings of a panic attack threatened.</p>
<p class="body-text">Ethan was in no shape to take care of himself, much less a
					baby. How could she be so stupid, so incompetent to forget that a baby was in
					her care after what had happened to Zack?</p>
<p class="body-text">“God has not given me the spirit of fear.” Approaching the
					couch, mind flashing photos of a dead child, she clasped a hand against her
					throat, panting.</p>
<p class="body-text">A pair of midnight-blue eyes blinked up at her from amidst the
					yellow-and-blue bunny blankets.</p>
<p class="body-text">Molly, limp with relief, melted to the floor beside the sofa.
					Laying her forehead against the cushions, she thanked God that little Laney had
					suffered no ill effects from her neglect. </p>
<p class="body-text">She was still there, attention glued to the baby, when Ethan
					began to stir. He thrust off all but one blanket and stood up.</p>
<p class="body-text">“Man, do I feel better.”</p>
<p class="body-text">As Molly looked up, her heart leaped wildly. He looked better,
					too. The UPS driver, scar and all, was a hunk!</p>
<p class="body-text">“You aren’t shaking anymore.” </p>
<p class="body-text">“No, but you are.” He frowned down at where she knelt beside
					the couch. “And you’re pale. Are you okay?”</p>
<p class="body-text">Molly pushed up from her spot on the oval rug and ran sweaty
					palms down the sides of her sweatpants. “Fine. How about that cup of cocoa
					now?”</p>
<p class="body-text">Anything to avoid the subject of why she was so afraid of a
					tiny baby.</p>
<p class="body-text">“Sounds good.” Weariness emanated from him. If she’d known him
					better and the situation had not been so serious, Molly would have teased him
					about the hot-pink blanket draped around his broad shoulders—an incongruous
					sight if ever there was one. </p>
<p class="body-text">“How about a bowl of beef stew with that cocoa?”</p>
<p class="body-text">“Did anyone ever tell you you’re a nice lady?”</p>
<p class="body-text">“I take it you haven’t had supper?”</p>
<p class="body-text">“Coffee and brownies, but they’re long gone.”</p>
<p class="body-text">“Did you get all the way up to Chester’s?”</p>
<p class="body-text">He nodded his head. “Yes, thank God.”</p>
<p class="body-text">“It couldn’t have been easy.”</p>
<p class="body-text">“No, but my part was a lot easier than Chester’s. He’s one
					tough character.”</p>
<p class="body-text">Still, Molly couldn’t help but admire Ethan’s determination to
					help another person under such dire circumstances.</p>
<p class="body-text">The clock had been ticking and Chester’s life had depended upon
					Ethan—and the Lord—to get the medication there on time. </p>
<p class="body-text">Molly hustled into the kitchen, returning in a matter of
					minutes with the hot meal.</p>
<p class="body-text">Ethan settled on the end of the couch next to Laney and told
					Molly about the trip up the mountain, the hours with Chester, and finally about
					the truck sliding into a ditch.</p>
<p class="body-text">“Don’t know how I made it in that light-bodied van.” He shook
					his head and corrected himself. “Yes, I do. The Lord.” He dug into the steaming
					bowl of soup. “Hot stew sure hits the spot.”</p>
<p class="body-text">Somehow she’d known Ethan was a Christian, though she’d learned
					the hard way that not all Christians were as self-sacrificing.</p>
<p class="body-text">But Ethan was a man who took responsibility seriously and
					didn’t give up easily. She liked that about him. </p>
<p class="body-text">She liked the way he ate, too, like her dad and uncles,
					wholeheartedly as though he might never eat again. His appreciation of a simple
					bowl of stew made her smile.</p>
<p class="body-text">From what little she’d seen, and from the way he cared for his
					child, Molly thought she could find a lot of things to like about Ethan
					Hunter.</p>
<p class="body-text">He took a bite of cornbread, chewed and swallowed. “I hate to
					ask this of you, but I don’t have a way back to town tonight. You wouldn’t
					happen to have a bunkhouse or a barn I could sleep in, would you? Just for
					tonight, I mean. If my van was here, I could sleep in that, but…” He lifted one
					shoulder in a shrug.</p>
<p class="body-text">“There’s a barn, but you would freeze out there.” </p>
<p class="body-text">Practical to the bone, impropriety didn’t concern Molly, but it
					would upset Aunt Patsy. She shifted uncomfortably, fretting. Letting a man
					freeze to death would be a lot worse than letting him spend the night. “I have
					an extra room in back. There’s no heat, but…”</p>
<p class="body-text">She let her voice trail off, uncertain how to handle the
					situation.</p>
<p class="body-text">“No. It wouldn’t be right for me to impose on you that way. If
					you’ll keep Laney inside, I’ll take the barn.”</p>
<p class="body-text">Molly jumped. Her windpipe tightened.</p>
<p class="body-text">“No. That’s not a good idea.” Her heart thundered in her chest
					as she searched for a solution. No way could she spend an entire night alone
					with Laney.</p>
<p class="body-text">Ethan studied her curiously. “I’m sorry she’s so much
					trouble.”</p>
<p class="body-text">“It’s not that—” How did she explain without admitting the ugly
					truth—that she was a danger to his child. She couldn’t, so instead she searched
					for a viable solution.</p>
<p class="body-text">“My uncle Robert keeps his fishing camper here during the
					winter months. It’s self-contained and has a small propane heater. It stays cozy
					and snug once it’s warmed up. I’m sure he wouldn’t mind if you used it.”</p>
<p class="body-text">Ethan seemed relieved. He placed his bowl on the coffee table.
					“That will work great. I don’t know how I’ll ever thank you for this,
					Molly.”</p>
<p class="body-text">He was the hero, risking life and limb to help a sick man. She
					was a coward who wouldn’t have done anything at all had he not forced her. She
					suddenly felt ashamed.</p>
<p class="body-text">He drew in a breath and leaned forward, forearms on his thighs,
					palms pressed together. “So if you have that camper key, I’ll go check it out,
					light the stove and such. Will you watch Laney while I go?”</p>
<p class="body-text">No! As soon as the thought came, shame followed. If Ethan had
					nearly frozen to death to help someone else, surely she could find the courage
					to stay in a warm house with his baby for a few more minutes. She swallowed back
					the knot of anxiety. She could. She had to.</p>
<p class="body-text">Pushing out of her chair, Molly went to the bedroom. When she
					returned with the camper keys clenched in one hand, Ethan was changing Laney’s
					diaper.</p>
<p class="body-text">She stopped dead in her tracks and watched. Something about a
					big, masculine man maneuvering a diaper around the chubby, thrashing legs
					created an endearing scene.</p>
<p class="body-text">Ethan looked up and grinned, and Molly’s heart fluttered oddly. </p>
<p class="body-text">“She leaks like a sprinkler system.” Deftly, he smoothed the
					plastic tabs into place before slipping the tiny legs into the pajamas.</p>
<p class="body-text">“You’re good at that.”</p>
<p class="body-text">“Practice.” He lifted the infant in his big hands and laid her
					against a wide, blanket-covered shoulder, patting the tiny back with a
					tenderness that stirred Molly. One of his hands covered Laney’s entire back.</p>
<p class="body-text">“She’s beautiful.” Molly swallowed a lump and wished for what
					could never be.</p>
<p class="body-text">“Yeah.”</p>
<p class="body-text">To break the spell of man and baby, Molly stuck out her hand,
					displaying the keys. “The camper is behind the detached garage. The propane
					bottle is still hooked up so all you have to do is light the stove. You can take
					these blankets with you.”</p>
<p class="body-text">“Perfect.” He took the keys and rose, bringing Laney up with
					him. “Do you mind feeding her?”</p>
<p class="body-text">Before Molly knew what was about to happen, Ethan placed the
					baby in her arms. The soft, warm body cuddled into her and made sucking noises
					against the little fist. </p>
<p class="body-text">Two years. Two long years since she’d held a baby in her
					arms.</p>
<p class="body-text">Molly thought she would collapse on the spot.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter-02.vue?57e08ffa